import React from 'react';
import { styled as styled2 } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

type Props = {
	title: string;
};

export function ChannelsTitleView({ title }: Props) {
	return getWillShowNav4() ? (
		<Box xcss={headingStyles}>
			<Heading size="xsmall">{title}</Heading>
		</Box>
	) : (
		<Text
			{...(fg('jsm_queue_a11y_improvement_batch4') ? { id: 'customers-channel-dialog' } : {})}
			size="medium"
			as="h3"
		>
			{title}
		</Text>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Text = styled2(Heading)({
	margin: 0,
	marginBottom: token('space.200'),
});

const headingStyles = xcss({
	margin: 'space.100',
});
